import { useState } from "react";
import { toast } from "sonner";
import { Upload, FileCheck, Loader2, Shield } from "lucide-react";
import { api, API } from "../lib/api";
import { Button } from "./ui/button";

export default function DocumentUploader({ kind, label, hint, value, onChange }) {
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) { toast.error("Max 10 MB"); return; }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post(`/uploads?kind=${kind}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange?.(data.path);
      toast.success(`${label} uploaded`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Upload failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="p-4 rounded-xl bg-slate-900/60 border border-slate-800" data-testid={`uploader-${kind}`}>
      <div className="flex items-start gap-3">
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 ${value ? "bg-emerald-500/20 text-emerald-400" : "bg-slate-800 text-slate-400"}`}>
          {value ? <FileCheck className="w-5 h-5" /> : <Shield className="w-5 h-5" />}
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-medium text-sm">{label}</p>
          <p className="text-xs text-slate-500">{hint}</p>
          {value && <p className="text-xs text-emerald-400 mt-1 font-mono truncate">✓ uploaded</p>}
        </div>
        <label>
          <input type="file" accept="image/*,application/pdf" className="hidden" onChange={pick} disabled={busy} data-testid={`input-${kind}`} />
          <Button type="button" variant="outline" size="sm" asChild className="bg-transparent border-slate-700 cursor-pointer hover:bg-slate-800">
            <span>{busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <><Upload className="w-3.5 h-3.5 mr-1.5" />{value ? "Replace" : "Upload"}</>}</span>
          </Button>
        </label>
      </div>
    </div>
  );
}
